/* @flow */
/*
 *  Copyright 2017 Adobe Systems Incorporated. All rights reserved.
 *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License. You may obtain a copy
 *  of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under
 *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 *  OF ANY KIND, either express or implied. See the License for the specific language
 *  governing permissions and limitations under the License.
 *
 */

import React, {Component} from 'react';
import './CCInstallationDialog.scss';
import PDPScss from '../../AppsPDP/AppsPDP.scss';
import Close from '@react/react-spectrum/Icon/Close';
import Dialog from '@react/react-spectrum/Dialog';
import AppsUtil from '../../../utils/AppsUtil';
import ThorConnectionUtil from '../../../utils/ThorConnectionUtil';
import CSSUtil from '../../../utils/CSSUtil';
import thorUtil from '../../../utils/wam/ThorUtil';
import AppsAnalytics from '../../../analytics/AppsAnalytics';
import Kaizen from '../../CCD/DownloadScreen/Kaizen/Kaizen';

type Props = {
	environment: string,
	intl: Object,
	locale: string,
	closeCCInstallationDialog: Function,
	eventSource: string,
	history: Object,
	setThor: Function,
	updateProductsPostThorCheck: Function
};

class CCInstallationDialog extends Component<Props> {
	thorDetected: boolean;
	sendAnalytic: Function;

	constructor(props: Props) {
		super(props);
		this.thorDetected = false;
		this.sendAnalytic = this.sendAnalytic.bind(this);
	}

	componentDidMount() {
		document.getElementsByTagName('body')[0].style.overflow = 'hidden';
		this.sendAnalytic('render');
		const dialogNode = document.querySelector('.PDPDialogContent.spectrum-Dialog');
		if (dialogNode) {
			CSSUtil.addClass(dialogNode.parentNode,'dialogWrapper downloadKaizen');
			CSSUtil.addClass(dialogNode.parentNode,'alignCCDDesign');
			this.checkHeight();
		}
		this.sendAnalytic('download');
		CSSUtil.showInstallerPopUp(false);
		ThorConnectionUtil.refreshToHome((wamConfig) => {
			thorUtil.getWAMClient().connectToWam(wamConfig);
		}, () => {
			this.thorDetected = true;
			this.props.setThor(true);
			this.props.updateProductsPostThorCheck();
			this.props.closeCCInstallationDialog(true);
		}, () => {}, true);
		if (window.location.hash === '') {
			this.props.closeCCInstallationDialog(true);
		}
	}


	sendAnalytic(type: string, eventValue?: string) {
		const appsAnalytics = new AppsAnalytics(this.props.environment);
		appsAnalytics.initAnalytics();

		// Prefix - toast or banner
		const passedEventValue = eventValue ? eventValue : type;
		const modifiedEventValue = this.props.eventSource ? `${this.props.eventSource}-${passedEventValue}` : passedEventValue;
		const toastXstate = AppsUtil.getCCInstallationToastXButtonState() ? 'toastXClicked' : 'toastXUnclicked';
		const appConfig = {sapCode:'KCCC', displayName:'Creative Cloud', type: toastXstate, entitled: !AppsUtil.isUserFree()};

		switch (type) {
			case 'render':
				appsAnalytics.genericAnalyticEvent(appConfig, 'render','cc-installation-dialog','Modal', undefined, undefined, modifiedEventValue);
				break;
			// case 'need-help':
			// 	appsAnalytics.genericAnalyticEvent(appConfig, 'click','cc-installation-need-help','Modal', undefined, undefined, modifiedEventValue);
			// 	break;
			case 'close':
				appsAnalytics.genericAnalyticEvent(appConfig, 'click','cc-installation-close','Modal', undefined, undefined, modifiedEventValue);
				break;
			case 'download':
				appsAnalytics.onAppDownloadEvent(appConfig, 'App Installation');
				break;
			// case 'restart-download':
			// 	appsAnalytics.genericAnalyticEvent(appConfig, 'click', 'cc-installation-restart-download', 'Modal', undefined, undefined, modifiedEventValue);
			// 	break;
		}
	}


	checkHeight() {
		const appsInstallationWrapper = document.querySelector('#appsInstallationWrapperNew');
		const installationDialogContent = document.getElementsByClassName('InstallationDialogContent')[0];
		if (appsInstallationWrapper && this.refs.InstallationDialogContent && document.body && document.body.offsetHeight > appsInstallationWrapper.offsetHeight) {
			installationDialogContent.style.height = '100%';
			installationDialogContent.style.margin = '0rem';
		}
	}

	componentWillUnmount() {
		document.getElementsByTagName('body')[0].style.overflow = '';
		// Send close event analytics
		if (this.thorDetected) {
			// Dialog was closed because thor was detected
			this.sendAnalytic('close', 'auto-thorDetect');
		}
		else if (!location.hash) {
			// Dialog was closed because user clicked on back button
			this.sendAnalytic('close', 'auto-backNavigation');
		}
		if (location.hash) {
			this.props.history.replace(location.pathname + location.search);
		}
	}

	renderPage() {
		const appsAnalytics = new AppsAnalytics(this.props.environment);
		const productDetails = {
			name: 'Creative Cloud',
			id: 'creative-cloud',
			sapCode: 'KCCC'
		};
		return <Kaizen {...this.props} isCCH={true} intl={this.props.intl} locale={this.props.locale} product={productDetails} genericPDPAnalyticEvent={appsAnalytics.genericPDPAnalyticEvent} sendAnalyticCC={this.sendAnalytic}/>;
	}

	render() {
		return (
			<Dialog key='dialogInstallation' id='InstallationDialog' ref='InstallationDialogContent' className='CCInstallation PDPDialogContent installationNew installation InstallationDialogContent'>
				<div id='appsInstallationWrapperNew' className={PDPScss.appsPDPWrapper}>
					<div className={PDPScss.header}>
						<div className={PDPScss.toolBar}>
							<div tabIndex={0} role='button' aria-label='Close' className={`${PDPScss.closeContainer} closeContainer`} onKeyDown={(e) => {if (e.key === 'Enter') {this.sendAnalytic('close');this.props.closeCCInstallationDialog();}}}>
								<Close className={`closeIcon ${PDPScss.closeIcon}`} size='S' onClick={() => {this.sendAnalytic('close');this.props.closeCCInstallationDialog(true);}}/>
							</div>
						</div>
					</div>
					<div key='installationWrapperNew' className ='installationWrapperNew addDummySpaceForTopNav'>
						<div>
							{this.renderPage()}
						</div>
					</div>
				</div>
			</Dialog>
		);
	}
}

export default CCInstallationDialog;
